var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 21.194 22.5 30 16.3889 38.3333C15.5741 39.4444 14.4259 39.4444 13.6111 38.3333C7.5 30 0 21.3584 0 15C0 6.71573 6.71573 0 15 0C23.2842 0 30 6.71573 30 15Z",
    fill: "#7AC142"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15 0C6.71573 0 0 6.71573 0 15C0 21.3584 7.5 30 13.6111 38.3333C14.4444 39.4697 15.5741 39.4444 16.3889 38.3333C22.5 30 30 21.194 30 15C30 6.71573 23.2842 0 15 0ZM15 1.11111C22.6838 1.11111 28.8889 7.31622 28.8889 15C28.8889 17.6652 27.2173 21.3127 24.6897 25.2648C22.162 29.2168 18.5612 33.4913 15.4927 37.6758C15.2704 37.9787 15.1252 38.1363 15 38.2682C14.8748 38.1363 14.7296 37.9787 14.5073 37.6758C11.4272 33.4756 8.23875 29.238 5.57291 25.3038C2.90709 21.3697 1.11111 17.7261 1.11111 15C1.11111 7.31622 7.31622 1.11111 15 1.11111Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 6.66797C10.3985 6.66797 6.66602 10.4004 6.66602 15.0013C6.66602 19.6022 10.3985 23.3346 14.9994 23.3346C19.6002 23.3346 23.3327 19.6022 23.3327 15.0013C23.3327 10.4004 19.6002 6.66797 14.9994 6.66797ZM14.5651 21.6813V16.4542H11.6594L15.8344 8.32128V13.5484H18.6316L14.5651 21.6813Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.2fde46824f7b64c9bee904b04c53bab4.svg";
export { ForwardRef as ReactComponent };